// i18n Translation Dictionary

const dictionaries = {
  th: {
    // Navigation & Common
    nav_home: 'หน้าหลัก',
    nav_history: 'ประวัติ',
    nav_profile: 'โปรไฟล์',
    btn_back: '← ย้อนกลับ',
    btn_next: 'ถัดไป →',
    btn_cancel: 'ยกเลิก',
    btn_confirm: 'ยืนยัน',
    btn_save: 'บันทึกข้อมูล',

    // Home
    home_title: 'ดวงชะตา พยากรณ์',
    home_subtitle: 'ให้คำปรึกษาและไขข้อข้องใจผ่านศาสตร์แห่งดวงดาวและการพยากรณ์',
    service_onsite: '🏠 นัดพบ',
    service_chat: '💬 แชท',
    service_call: '📞 แจ้งผ่านโทรศัพท์',
    service_video: '📹 วิดีโอคอล',
    btn_book_now: '✨ จองคิวดูดวง',

    // Booking Flow
    booking_step1_title: 'เลือกบริการ',
    booking_step1_desc: 'กรุณาเลือกรูปแบบที่สะดวก',
    booking_step2_title: 'เลือกวันเวลา',
    booking_step2_desc: 'คิวว่างที่เปิดรับจอง',
    booking_step3_title: 'ยืนยันการจอง',
    
    booking_review_title: '📋 รายละเอียดการจอง',
    booking_lbl_service: 'บริการ',
    booking_lbl_datetime: 'วันเวลา',
    booking_lbl_price: 'ราคา',
    booking_input_note: 'เรื่องที่ต้องการถาม...',
    btn_confirm_booking: '✨ ยืนยันจอง',

    // Booking Success
    booking_success_title: '🎉 จองคิวสำเร็จ!',
    booking_success_desc: 'กรุณาชำระเงินตามช่องทางด้านล่าง เพื่อยืนยันคิวของคุณ',
    payment_domestic: 'โอนเงินในประเทศ',
    payment_kbank: 'กสิกรไทย (KBANK)',
    payment_international: 'International Transfer',
    payment_swift: 'SWIFT Code:',
    payment_branch: 'Branch Code:',
    payment_account_name: 'ชื่อบัญชี',
    payment_account_num: 'เลขบัญชี',
    btn_submit_info: '⚖️ บันทึกข้อมูลดวงชะตา',
    btn_later: '🏠 ภายหลัง',

    // History & Cards
    history_title: '📋 ประวัติการจอง',
    card_title: '✨ รายการจองคิวดูดวง',
    status_pending: 'รอชำระเงิน',
    status_paid: 'กำลังรอตรวจสอบ',
    status_confirmed: 'ยืนยันแล้ว',
    status_cancelled: 'ยกเลิก',
    status_completed: 'เสร็จสิ้น',
    lbl_customer: 'ลูกค้า:',
    lbl_note: 'หมายเหตุ:',
    btn_cancel_booking: 'ยกเลิก',

    // Payment / Data Entry Page
    payment_title: '💸 บันทึกข้อมูลดวงชะตา',
    payment_desc: 'กรอกข้อมูลด่วนก่อนไปโอนเงินและส่งสลิปในแชท LINE',
    payment_section_astrology: 'ข้อมูลดวงชะตา',
    payment_lbl_tel: 'เบอร์โทรศัพท์',
    payment_lbl_tel_hint: 'สำหรับติดต่อกรณีฉุกเฉิน',
    profile_title: 'ข้อมูลส่วนตัว',
    profile_role_admin: '🔮 หมอดู / แอดมิน',
    profile_role_user: '👤 ลูกดวง',
    profile_stat_total: 'การจองทั้งหมด',
    profile_stat_confirmed: 'ยืนยันแล้ว',
    profile_lbl_name: 'ชื่อ',
    payment_lbl_dob: 'วันเดือนปีเกิด',
    payment_lbl_tob: 'เวลาเกิด',
    payment_lbl_height: 'ส่วนสูง (ซม.)',
    payment_lbl_pob: 'สถานที่เกิด',
    payment_lbl_pob_hint: 'เช่น กรุงเทพฯ, เชียงใหม่',
    toast_fill_all: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    toast_save_success: 'บันทึกข้อมูลสำเร็จ! กรุณาส่งสลิปโอนเงินในแชท LINE',
    
    // Profile
    profile_title: '👤 โปรไฟล์ของฉัน',
    profile_uid: 'รหัสผู้ใช้:',
    profile_phone: 'เบอร์โทร:',
    profile_not_set: 'ยังไม่ระบุ',
    profile_btn_refresh: 'รีเฟรชข้อมูล',
    profile_btn_logout: '🚪 ล็อกเอาท์',
    btn_contact_admin: 'ติดต่อแอดมิน (@vtx4482v)',
    profile_version: 'ระบบพยากรณ์ v1.0',

    // Date
    date_months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
    date_days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    date_time_format: '{date} เวลา {time} น.',
  },
  
  en: {
    // Navigation & Common
    nav_home: 'Home',
    nav_history: 'History',
    nav_profile: 'Profile',
    btn_back: '← Back',
    btn_next: 'Next →',
    btn_cancel: 'Cancel',
    btn_confirm: 'Confirm',
    btn_save: 'Save Details',

    // Home
    home_title: 'Astrology Readings',
    home_subtitle: 'Find guidance and clarity through astrology and spiritual insights.',
    service_onsite: '🏠 In-person',
    service_chat: '💬 Chat',
    service_call: '📞 Voice Call',
    service_video: '📹 Video Call',
    btn_book_now: '✨ Book a Session',

    // Booking Flow
    booking_step1_title: 'Select Service',
    booking_step1_desc: 'Choose your preferred reading format',
    booking_step2_title: 'Select Date & Time',
    booking_step2_desc: 'Available timeslots',
    booking_step3_title: 'Confirm Booking',
    
    booking_review_title: '📋 Booking Details',
    booking_lbl_service: 'Service',
    booking_lbl_datetime: 'Date/Time',
    booking_lbl_price: 'Price',
    booking_input_note: 'Any specific questions or topics you want to ask...',
    btn_confirm_booking: '✨ Confirm Booking',

    // Booking Success
    booking_success_title: '🎉 Booking Successful!',
    booking_success_desc: 'Please send your payment via the options below to confirm your slot.',
    payment_domestic: 'Domestic Transfer (Thailand)',
    payment_kbank: 'Kasikornbank (KBANK)',
    payment_international: 'International Transfer',
    payment_swift: 'SWIFT Code:',
    payment_branch: 'Branch Code:',
    payment_account_name: 'Account Name',
    payment_account_num: 'Account Number',
    btn_submit_info: '⚖️ Provide Birth Details',
    btn_later: '🏠 Do it later',

    // History & Cards
    history_title: '📋 Booking History',
    card_title: '✨ Astrology Session',
    status_pending: 'Awaiting Payment',
    status_paid: 'Under Review',
    status_confirmed: 'Confirmed',
    status_cancelled: 'Cancelled',
    status_completed: 'Completed',
    lbl_customer: 'Customer:',
    lbl_note: 'Note:',
    btn_cancel_booking: 'Cancel',

    // Payment / Data Entry Page
    payment_title: '💸 Astrology Birth Details',
    payment_desc: 'Please provide your birth details before sending the payment slip via LINE.',
    payment_section_astrology: 'Birth Chart Details',
    payment_lbl_tel: 'Phone Number',
    payment_lbl_tel_hint: 'For emergency contact',
    profile_title: 'Personal Info',
    profile_role_admin: '🔮 Admin / Astrologer',
    profile_role_user: '👤 Client',
    profile_stat_total: 'Total Bookings',
    profile_stat_confirmed: 'Confirmed',
    profile_lbl_name: 'Name',
    payment_lbl_dob: 'Date of Birth',
    payment_lbl_tob: 'Time of Birth',
    payment_lbl_height: 'Height (cm)',
    payment_lbl_pob: 'Place of Birth',
    payment_lbl_pob_hint: 'e.g. Bangkok, TH',
    toast_fill_all: 'Please fill out all the required details.',
    toast_save_success: 'Saved! Please send your payment slip via LINE chat.',

    // Profile
    profile_title: '👤 My Profile',
    profile_uid: 'User ID:',
    profile_phone: 'Phone:',
    profile_not_set: 'Not specified',
    profile_btn_refresh: 'Refresh Info',
    profile_btn_logout: '🚪 Logout',
    btn_contact_admin: 'Contact Admin (@vtx4482v)',
    profile_version: 'Astrology System v1.0',

    // Date
    date_months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    date_days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    date_time_format: '{date} at {time}',
  }
};

let currentLang = localStorage.getItem('i18n_lang') || 'th';

export function setLanguage(lang) {
  if (dictionaries[lang]) {
    currentLang = lang;
    localStorage.setItem('i18n_lang', lang);
    return true;
  }
  return false;
}

export function getLanguage() {
  return currentLang;
}

export function t(key) {
  return dictionaries[currentLang]?.[key] || dictionaries['th'][key] || key;
}

window.toggleLanguage = function() {
  const newLang = currentLang === 'th' ? 'en' : 'th';
  setLanguage(newLang);
  window.location.reload();
}
